import { baseUrl, onTokenExpired } from "./apiConfig";

const getUserRoles = async (token) =>{
    return fetch(baseUrl+'/api/roles',{
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + token
          }
    }).then((response)=>{
        if(response.status===200){
            return response.json();
        }

        if(response.status===401){
            return onTokenExpired().then((newToken)=>{
              return getUserRoles(newToken)
            })
          }
    
        throw new Error("error")
    })
}

export {getUserRoles};